import { createContext, useContext, useLayoutEffect, useState } from 'react';
import TabScroller from './TabScroller.jsx';
import { createPortal } from 'react-dom';

export const ModuleNavigationContext = createContext(null);

/** Keeps module state in its route while presenting its tabs in the shell. */
export default function ModuleNavigation({ children }) {
  const context = useContext(ModuleNavigationContext);
  const [host] = useState(() => document.createElement('div'));
  host.className = 'navigation-tab-host';
  const target = context?.target;
  useLayoutEffect(() => {
    if (!target) return undefined;
    target.append(host);
    return () => host.remove();
  }, [host, target]);
  const register = context?.register;
  useLayoutEffect(() => {
    if (!register) return undefined;
    register(true);
    return () => register(false);
  }, [register]);
  if (!context) return children;
  return createPortal(<TabScroller>{children}</TabScroller>, host);
}
